import type { DeepString } from "@/lib/i18n";

export const pl = {
  readMore: "Czytaj więcej",
  empty: "Brak popularnych wpisów.",
} as const;

export type WBlogPopularPostsTranslations = DeepString<typeof pl>;
